// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-question .v-input__control {\n  border: none;\n  border-radius: 3px;\n  min-height: 35px !important;\n}\n.preview-question .v-input__control .v-input__slot {\n  box-shadow: inset 0px 2px 5px rgba(197, 208, 228, 0.62) !important;\n}\n.preview-question .v-input__control .v-input__slot input {\n  font-size: 12px;\n}\n.preview-question .v-input__control .v-input__slot input::placeholder {\n  color: #5d6b88;\n}", ""]);
// Exports
module.exports = exports;
